<template>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <card class="custom-shadow-card-header">
        <div class="row tac">
          <div class="col-sm-6 col-md-3">
            <label for="">Posición: </label>
            <br />
            <el-select
              clearable
              filterable
              class="select-default mb-3 shadow-sm"
              placeholder="Seleccione..."
              v-model="idStation"
              @change="handleView()"
            >
              <el-option
                class="select-default"
                label="Posición Actual"
                :value="0"
              >
              </el-option>
              <el-option
                class="select-default"
                v-for="(station, index) in stations"
                :key="index"
                :label="station.name"
                :value="station.id"
              >
              </el-option>
            </el-select>
            <div
              class="text-center"
              v-if="currently.currently && Object.keys(currently).length > 0"
            >
              <img
                alt=""
                style="width: 75px"
                v-bind:src="`/static/img/iconos/${currently.currently.icon}.svg`"
              />
              <br />
              <p v-bind:style="`font-family: 'Open Sans', sans-serif`">
                {{ currently.currently.summary }}
              </p>
            </div>
            <div :class="currently.currently ? `text-center` : `text-left`">
              <p
                class="text-muted"
                v-bind:style="`
                  font-size: 20px;
                  font-family: 'Open Sans', sans-serif;
                  font-weight: bold;`"
              >
                {{ currentTime }}
              </p>
            </div>
          </div>
          <div
            class="col-sm-6 col-md-9"
            v-if="currently.currently && Object.keys(currently).length > 0"
          >
            <div class="row">
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/temperatura.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.temperature, 1)
                  }}&deg;C</span
                >
                <br />
                <span class="text-muted"><strong>Temperatura</strong></span>
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/humedad.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.humidity * 100, 2)
                  }}%</span
                >
                <br />
                <span class="text-muted"><strong>Humedad</strong></span>
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/rain.svg" />
                <span style="margin-left: 10px"
                  >{{
                    roundNumber(currently.currently.precipIntensity, 2)
                  }}
                  mm/h</span
                >
                <br />
                <span class="text-muted"><strong>Precipitación</strong></span>
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/lluvia.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.precipProbability * 100, 2)
                  }}%</span
                >
                <br />
                <span class="text-muted"><strong>Prob. de LLuvia</strong></span>
              </div>
            </div>
            <hr />
            <br />
            <div class="row other-climate">
              <div
                class="col-md text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/viento.svg" />
                <p class="text-muted">
                  <strong>Viento:</strong> <br />{{
                    roundNumber(currently.currently.windSpeed * 3.6, 2)
                  }}
                  Km/h
                </p>
              </div>
              <div
                class="col-md text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/barometro.svg" />
                <p class="text-muted">
                  <strong>Presi&oacuten:</strong><br />
                  {{ currently.currently.pressure }} mb
                </p>
              </div>
              <div
                class="col-md text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/rocio.svg" />
                <p class="text-muted">
                  <strong>Punto Roc&iacuteo:</strong><br />
                  {{ currently.currently.dewPoint }}&deg;C
                </p>
              </div>
              <div
                class="col-md text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/cloudy.svg" />
                <p class="text-muted">
                  <strong>Nubes:</strong><br />
                  {{ roundNumber(currently.currently.cloudCover * 100, 2) }}%
                </p>
              </div>
              <div
                class="col-md text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/niebla.svg" />
                <p class="text-muted">
                  <strong>Visibilidad:</strong><br />
                  {{ roundNumber(currently.currently.visibility, 2) }} Km
                </p>
              </div>
              <!--<div class="col-md text-center">
                <img alt="" src="/static/img/iconos/ozono.svg" />
                <p class="text-muted">
                  <strong>Ozono:</strong><br />
                  {{ currently.currently.ozone }} U.D.
                </p>
              </div>-->
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ messageAPI }}
            </h5>
          </div>
        </div>
      </card>

      <div class="row" v-if="currently.currently">
        <div class="col-12 map-climate" style="margin-bottom: 30px !important">
          <div ref="map" class="map" v-if="renderComponent"></div>
          <div
            id="toolbarDiv"
            class="esri-component esri-widget"
            v-if="renderComponent"
          >
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              title="Distance Measurement Tool"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              title="Area Measurement Tool"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              title="Clear Measurements"
            ></button>
          </div>
        </div>
      </div>

      <card class="custom-shadow-card-header" v-if="currently.currently">
        <div class="row">
          <div class="col-12">
            <span class="text-muted"
              >Pronóstico del Clima (Próximo 6 días)</span
            >
            <hr />
            <vue-tabs @tab-change="handleTabChange">
              <v-tab
                v-for="(day, index) in currently.fullWeek"
                :key="index"
                :title="day"
              >
                <br />
                <div class="row">
                  <div class="text-center col-xs-12 col-sm-3 col-md-2">
                    <img
                      alt=""
                      style="width: 75px"
                      v-bind:src="`/static/img/iconos/${currently.daily.data[index].icon}.svg`"
                    />
                    <br />
                    <p v-bind:style="`font-family: 'Open Sans', sans-serif`">
                      {{ currently.daily.data[index].summary }}
                    </p>
                  </div>
                  <div class="col-xs-12 col-sm-9 col-md-10">
                    <div class="row">
                      <div
                        class="col-12"
                        v-if="
                          currently.currently &&
                          Object.keys(currently).length > 0
                        "
                      >
                        <div class="row">
                          <div
                            class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                          >
                            <img
                              alt=""
                              src="/static/img/iconos/temperatura.svg"
                            />
                            <span
                              >{{
                                roundNumber(
                                  currently.daily.data[index].temperatureMax,
                                  1
                                )
                              }}&deg;C</span
                            >
                            <br />
                            <span class="text-muted"
                              ><strong>Temperatura</strong></span
                            >
                          </div>
                          <div
                            class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                          >
                            <img alt="" src="/static/img/iconos/humedad.svg" />
                            <span
                              >{{
                                roundNumber(
                                  currently.daily.data[index].humidity * 100,
                                  2
                                )
                              }}%</span
                            >
                            <br />
                            <span class="text-muted"
                              ><strong>Humedad</strong></span
                            >
                          </div>
                          <div
                            class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                          >
                            <img alt="" src="/static/img/iconos/rain.svg" />
                            <span style="margin-left: 10px"
                              >{{
                                roundNumber(
                                  currently.daily.data[index].precipIntensity,
                                  2
                                )
                              }}
                              mm/h</span
                            >
                            <br />
                            <span class="text-muted"
                              ><strong>Precipitación</strong></span
                            >
                          </div>
                          <div
                            class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                          >
                            <img alt="" src="/static/img/iconos/lluvia.svg" />
                            <span
                              >{{
                                roundNumber(
                                  currently.daily.data[index]
                                    .precipProbability * 100,
                                  2
                                )
                              }}%</span
                            >
                            <br />
                            <span class="text-muted"
                              ><strong>Prob. de LLuvia</strong></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <div class="row other-climate">
                      <div
                        class="col-md text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/viento.svg" />
                        <p class="text-muted">
                          <strong>Viento:</strong> <br />{{
                            roundNumber(
                              currently.daily.data[index].windSpeed * 3.6,
                              2
                            )
                          }}
                          Km/h
                        </p>
                      </div>
                      <div
                        class="col-md text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/barometro.svg" />
                        <p class="text-muted">
                          <strong>Presi&oacuten:</strong><br />{{
                            currently.daily.data[index].pressure
                          }}
                          mb
                        </p>
                      </div>
                      <div
                        class="col-md text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/rocio.svg" />
                        <p class="text-muted">
                          <strong>Punto Roc&iacuteo:</strong><br />{{
                            currently.daily.data[index].dewPoint
                          }}&deg;C
                        </p>
                      </div>
                      <div
                        class="col-md text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/cloudy.svg" />
                        <p class="text-muted">
                          <strong>Nubes:</strong><br />{{
                            roundNumber(
                              currently.daily.data[index].cloudCover * 100,
                              2
                            )
                          }}%
                        </p>
                      </div>
                      <div
                        class="col-md text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/niebla.svg" />
                        <p class="text-muted">
                          <strong>Visibilidad:</strong><br />{{
                            roundNumber(
                              currently.daily.data[index].visibility,
                              2
                            )
                          }}
                          Km
                        </p>
                      </div>
                      <!--<div class="col-md text-center">
                        <img alt="" src="/static/img/iconos/ozono.svg" />
                        <p class="text-muted">
                          <strong>Ozono:</strong><br />{{
                            currently.daily.data[index].ozone
                          }}
                          U.D.
                        </p>
                      </div>-->
                    </div>
                  </div>
                  <div class="col-12">
                    <br />
                    <br />
                    <p
                      class="text-center text-muted"
                      v-bind:style="`font-family: 'Open Sans', sans-serif`"
                    >
                      Temp Min:
                      {{ currently.daily.data[index].temperatureMin }} - Temp
                      Max: {{ currently.daily.data[index].temperatureMax }}
                    </p>
                    <el-slider
                      class="slider-info"
                      style="margin: 0 90px"
                      v-model="rangeSlider"
                      :max="40"
                      :min="10"
                      :marks="marks"
                      :range="true"
                      :disabled="false"
                    >
                    </el-slider>
                    <br />
                  </div>
                </div>
                <br />
                <br />
              </v-tab>
            </vue-tabs>
          </div>
        </div>
      </card>

      <card class="custom-shadow-card-header" v-if="currently.currently">
        <span
          v-if="
            Object.keys(chartOptions).length > 0 &&
            Object.values(chartOptions.xAxis.categories).length
          "
        >
          <div class="row">
            <div class="col-12">
              <highcharts :options="chartOptions"></highcharts>
            </div>
          </div>
        </span>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            Usted no tiene permisos para ver el gráfico asignado en este
            espacio.
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Slider } from 'element-ui';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinCharts from 'src/util/mixinCharts';
import MixinNumbers from 'src/util/mixinNumbers';
import SweetAlert from 'src/class/Alerts';
import VueTabs from 'vue-nav-tabs';
import axios from 'axios';
import moment from 'moment';
import { Chart } from 'highcharts-vue';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import mixinLocation from 'src/util/mixinLocation';

export default {
  components: {
    [VueTabs.name]: VueTabs,
    [Slider.name]: Slider,
    highcharts: Chart,
  },

  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      renderComponent: true,
      stations: [],
      currently: [],
      currentTime: moment().format('hh:mm:ss'),
      chartOptions: {},
      rangeSlider: null,
      idStation: 0,
      marks: {
        10: '10°C',
        20: '20°C',
        30: '30°C',
        40: '40°C',
        50: '50°C',
      },
      map: null,
      messageAPI:
        'Usted no tiene permisos para ver la información asignada en este espacio.',
    };
  },

  mixins: [
    MixinPermissions,
    MixinCharts,
    MixinNumbers,
    MixinArcgisMap,
    mixinMasters,
    MixinMenu,
    mixinLocation,
  ],

  methods: {
    handleTabChange(tabIndex, newTab, oldTab) {
      this.handleRange(
        this.currently.daily.data[tabIndex].temperatureMin,
        this.currently.daily.data[tabIndex].temperatureMax
      );
    },

    handleRange(min, max) {
      this.rangeSlider = [min, max];
    },

    handleView() {
      this.getDataClimateForecast(this.idStation);
    },

    getDataClimateForecast(idStation) {
      if (this.isClimateForecast()) {
        this.showHideLoading(true);
        if (idStation == 0) {
          this.getPosition().then(() => {
            Axios.getMasters(
              `weatherkitappleapi/getDataApi/${this.center.lat},${this.center.lng}`
            )
              .then((response) => {
                this.currently = response.data.data;
                this.chartOptions = this.spline(
                  'Pron\u00F3stico Clim\u00E1tico',
                  'Zona: Posición Actual',
                  this.currently.fullWeek,
                  this.currently.serie_bar
                );
                  this.loadMap();
                this.handleRange(
                  this.currently.daily.data[0].temperatureMin,
                  this.currently.daily.data[0].temperatureMax
                );
                this.showHideLoading();
              })
              .catch((error) => {
                this.showHideLoading();
                console.log(error);
                SweetAlert.warning(error.response.data.message);
                this.messageAPI = error.response.data.message;
              });
          });
        } else {
          Axios.getMasters(`weatherkitappleapi/getDataApi/${this.idStation}`)
            .then((response) => {
              this.currently = response.data.data;

              this.center.lat = this.currently.latitude
                ? parseInt(this.currently.latitude)
                : this.center.lat;
              this.center.lng = this.currently.longitude
                ? parseInt(this.currently.longitude)
                : this.center.lng;

               this.loadMap();

              let nameStation = '';
              for (let index = 0; index < this.stations.length; index++) {
                const element = this.stations[index];
                if (element.id == this.idStation) {
                  nameStation = element.name;
                  break;
                }
              }
              this.chartOptions = this.spline(
                'Pron\u00F3stico Clim\u00E1tico',
                'Zona: ' + nameStation,
                this.currently.fullWeek,
                this.currently.serie_bar
              );
              this.handleRange(
                this.currently.daily.data[0].temperatureMin,
                this.currently.daily.data[0].temperatureMax
              );
              this.showHideLoading();
            })
            .catch((error) => {
              this.showHideLoading();
              console.log(error);
              SweetAlert.warning(error.response.data.message);
              this.messageAPI = error.response.data.message;
            });
        }
      }
    },

    loadMap() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadBaseMap(null, true);

        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 7%;right: 30px';
        }, 10);
      });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('devices/stations/only/all')
        .then((response) => {
          this.stations = response.data.data;
          this.getDataClimateForecast(0, 'Pos. Actual');
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('climates');
  },

  destroyed() {
    this.deselectedItemOnMenu('climates');
  },
};
</script>
<style></style>
